import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { UrlService } from '@appShared/services/url.service'
import { AccountsService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { SubscriptionBillingComponent } from '../subscription-billing/subscription-billing.component'
import { SubscriptionMembershipComponent } from '../subscription-membership/subscription-membership.component'
import { AccountCardComponent } from '../account-card/account-card.component'
import { AccountDetailStore } from './account-detail.store'

export type AccountDetailPanel = 'membership' | 'billing'

@Component({
   selector: 'app-account-detail',
   templateUrl: './account-detail.component.html',
   styleUrls: ['./account-detail.component.less'],
   changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [SubscriptionBillingComponent, SubscriptionMembershipComponent, AccountCardComponent]
})
export class AccountDetailComponent implements OnInit {
   private readonly _urlService = inject(UrlService)
   private readonly _activatedRoute = inject(ActivatedRoute)
   private readonly _accountService = inject(AccountsService)
   private readonly _store = inject(AccountDetailStore)
   private readonly _router = inject(Router)
   private readonly _routes = SITE_DIRECTORY_ROUTES

   public accountSafeId: WritableSignal<string | null> = signal<string | null>(null)
   public accountIsLoading = this._store.accountIsLoading
   public accountErrorMessage = this._store.accountErrorMessage
   public actionableSubscription = this._store.actionableSubscription
   public activePanel: WritableSignal<AccountDetailPanel | null> = signal<AccountDetailPanel | null>('billing')
   public customerServiceUri = `/${this._routes.customerService.baseUri}`

   constructor(titleService: Title) {
      setTimeout(() => titleService.setTitle(this._routes.customerService.subscription.title))
   }

   ngOnInit(): void {
      const safeId = this._activatedRoute.snapshot.paramMap.get('id')
      this.accountSafeId.set(safeId)
      this._store.safeId.set(safeId)

      setTimeout(() => {
         this._urlService.setHeaderTitle(this._routes.customerService.subscription.title)
      })
   }

   togglePanel(panel: AccountDetailPanel): void {
      this.activePanel.update(current => (current === panel ? null : panel))
   }

   goBackToSearch(): void {
      // If the previous search produced a single result, clear it so the
      // search page doesn't immediately auto-navigate back here.
      if (this._accountService.accountSearchResults.value().length === 1) {
         this._accountService.clearSearch()
      }

      this._router.navigateByUrl(this.customerServiceUri)
   }
}
